// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v7.34.1
// source: sms.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "sms";

export interface SMSEnvPhoneNumbers {
  sandbox: string;
  preRelease: string;
  live: string;
}

export interface SMSTemplateReferences {
  topics: { [key: string]: boolean };
  flowSteps: { [key: string]: boolean };
  variables: { [key: string]: boolean };
  translations: { [key: string]: boolean };
}

export interface SMSTemplateReferences_TopicsEntry {
  key: string;
  value: boolean;
}

export interface SMSTemplateReferences_FlowStepsEntry {
  key: string;
  value: boolean;
}

export interface SMSTemplateReferences_VariablesEntry {
  key: string;
  value: boolean;
}

export interface SMSTemplateReferences_TranslationsEntry {
  key: string;
  value: boolean;
}

/** persisted messages */
export interface SMS {
  templates: SMSTemplate[];
}

export interface SMSTemplate {
  id: string;
  name: string;
  text: string;
  envPhoneNumbers: SMSEnvPhoneNumbers | undefined;
  references: SMSTemplateReferences | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt?: Date | undefined;
  updatedBy?: string | undefined;
  active: boolean;
}

/** commands */
export interface SMSCreateTemplate {
  id: string;
  name: string;
  text: string;
  envPhoneNumbers: SMSEnvPhoneNumbers | undefined;
  references: SMSTemplateReferences | undefined;
  active: boolean;
}

export interface UpdateSMSEnvPhoneNumbers {
  sandbox?: string | undefined;
  preRelease?: string | undefined;
  live?: string | undefined;
}

export interface SMSUpdateTemplate {
  id: string;
  name?: string | undefined;
  text?: string | undefined;
  envPhoneNumbers?: UpdateSMSEnvPhoneNumbers | undefined;
  references?: SMSTemplateReferences | undefined;
  active?: boolean | undefined;
}

export interface SMSDeleteTemplate {
  id: string;
}

export interface SMSDuplicateTemplate {
  id: string;
  name: string;
  text: string;
  envPhoneNumbers: SMSEnvPhoneNumbers | undefined;
  references: SMSTemplateReferences | undefined;
  active: boolean;
}

function createBaseSMSEnvPhoneNumbers(): SMSEnvPhoneNumbers {
  return { sandbox: "", preRelease: "", live: "" };
}

export const SMSEnvPhoneNumbers: MessageFns<SMSEnvPhoneNumbers> = {
  encode(message: SMSEnvPhoneNumbers, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sandbox !== "") {
      writer.uint32(10).string(message.sandbox);
    }
    if (message.preRelease !== "") {
      writer.uint32(18).string(message.preRelease);
    }
    if (message.live !== "") {
      writer.uint32(26).string(message.live);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSEnvPhoneNumbers {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSEnvPhoneNumbers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sandbox = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.preRelease = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.live = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSEnvPhoneNumbers {
    return {
      sandbox: isSet(object.sandbox) ? globalThis.String(object.sandbox) : "",
      preRelease: isSet(object.preRelease)
        ? globalThis.String(object.preRelease)
        : isSet(object.pre_release)
        ? globalThis.String(object.pre_release)
        : "",
      live: isSet(object.live) ? globalThis.String(object.live) : "",
    };
  },

  toJSON(message: SMSEnvPhoneNumbers): unknown {
    const obj: any = {};
    if (message.sandbox !== "") {
      obj.sandbox = message.sandbox;
    }
    if (message.preRelease !== "") {
      obj.preRelease = message.preRelease;
    }
    if (message.live !== "") {
      obj.live = message.live;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSEnvPhoneNumbers>): SMSEnvPhoneNumbers {
    return SMSEnvPhoneNumbers.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSEnvPhoneNumbers>): SMSEnvPhoneNumbers {
    const message = createBaseSMSEnvPhoneNumbers();
    message.sandbox = object.sandbox ?? "";
    message.preRelease = object.preRelease ?? "";
    message.live = object.live ?? "";
    return message;
  },
};

function createBaseSMSTemplateReferences(): SMSTemplateReferences {
  return { topics: {}, flowSteps: {}, variables: {}, translations: {} };
}

export const SMSTemplateReferences: MessageFns<SMSTemplateReferences> = {
  encode(message: SMSTemplateReferences, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.topics).forEach(([key, value]: [string, boolean]) => {
      SMSTemplateReferences_TopicsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    globalThis.Object.entries(message.flowSteps).forEach(([key, value]: [string, boolean]) => {
      SMSTemplateReferences_FlowStepsEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.variables).forEach(([key, value]: [string, boolean]) => {
      SMSTemplateReferences_VariablesEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    globalThis.Object.entries(message.translations).forEach(([key, value]: [string, boolean]) => {
      SMSTemplateReferences_TranslationsEntry.encode({ key: key as any, value }, writer.uint32(34).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplateReferences {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplateReferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = SMSTemplateReferences_TopicsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.topics[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = SMSTemplateReferences_FlowStepsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.flowSteps[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = SMSTemplateReferences_VariablesEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.variables[entry3.key] = entry3.value;
          }
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          const entry4 = SMSTemplateReferences_TranslationsEntry.decode(reader, reader.uint32());
          if (entry4.value !== undefined) {
            message.translations[entry4.key] = entry4.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplateReferences {
    return {
      topics: isObject(object.topics)
        ? (globalThis.Object.entries(object.topics) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      flowSteps: isObject(object.flowSteps)
        ? (globalThis.Object.entries(object.flowSteps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : isObject(object.flow_steps)
        ? (globalThis.Object.entries(object.flow_steps) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      variables: isObject(object.variables)
        ? (globalThis.Object.entries(object.variables) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
      translations: isObject(object.translations)
        ? (globalThis.Object.entries(object.translations) as [string, any][]).reduce(
          (acc: { [key: string]: boolean }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Boolean(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: SMSTemplateReferences): unknown {
    const obj: any = {};
    if (message.topics) {
      const entries = globalThis.Object.entries(message.topics) as [string, boolean][];
      if (entries.length > 0) {
        obj.topics = {};
        entries.forEach(([k, v]) => {
          obj.topics[k] = v;
        });
      }
    }
    if (message.flowSteps) {
      const entries = globalThis.Object.entries(message.flowSteps) as [string, boolean][];
      if (entries.length > 0) {
        obj.flowSteps = {};
        entries.forEach(([k, v]) => {
          obj.flowSteps[k] = v;
        });
      }
    }
    if (message.variables) {
      const entries = globalThis.Object.entries(message.variables) as [string, boolean][];
      if (entries.length > 0) {
        obj.variables = {};
        entries.forEach(([k, v]) => {
          obj.variables[k] = v;
        });
      }
    }
    if (message.translations) {
      const entries = globalThis.Object.entries(message.translations) as [string, boolean][];
      if (entries.length > 0) {
        obj.translations = {};
        entries.forEach(([k, v]) => {
          obj.translations[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplateReferences>): SMSTemplateReferences {
    return SMSTemplateReferences.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplateReferences>): SMSTemplateReferences {
    const message = createBaseSMSTemplateReferences();
    message.topics = (globalThis.Object.entries(object.topics ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.flowSteps = (globalThis.Object.entries(object.flowSteps ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.variables = (globalThis.Object.entries(object.variables ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    message.translations = (globalThis.Object.entries(object.translations ?? {}) as [string, boolean][]).reduce(
      (acc: { [key: string]: boolean }, [key, value]: [string, boolean]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Boolean(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseSMSTemplateReferences_TopicsEntry(): SMSTemplateReferences_TopicsEntry {
  return { key: "", value: false };
}

export const SMSTemplateReferences_TopicsEntry: MessageFns<SMSTemplateReferences_TopicsEntry> = {
  encode(message: SMSTemplateReferences_TopicsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplateReferences_TopicsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplateReferences_TopicsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplateReferences_TopicsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: SMSTemplateReferences_TopicsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplateReferences_TopicsEntry>): SMSTemplateReferences_TopicsEntry {
    return SMSTemplateReferences_TopicsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplateReferences_TopicsEntry>): SMSTemplateReferences_TopicsEntry {
    const message = createBaseSMSTemplateReferences_TopicsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseSMSTemplateReferences_FlowStepsEntry(): SMSTemplateReferences_FlowStepsEntry {
  return { key: "", value: false };
}

export const SMSTemplateReferences_FlowStepsEntry: MessageFns<SMSTemplateReferences_FlowStepsEntry> = {
  encode(message: SMSTemplateReferences_FlowStepsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplateReferences_FlowStepsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplateReferences_FlowStepsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplateReferences_FlowStepsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: SMSTemplateReferences_FlowStepsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplateReferences_FlowStepsEntry>): SMSTemplateReferences_FlowStepsEntry {
    return SMSTemplateReferences_FlowStepsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplateReferences_FlowStepsEntry>): SMSTemplateReferences_FlowStepsEntry {
    const message = createBaseSMSTemplateReferences_FlowStepsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseSMSTemplateReferences_VariablesEntry(): SMSTemplateReferences_VariablesEntry {
  return { key: "", value: false };
}

export const SMSTemplateReferences_VariablesEntry: MessageFns<SMSTemplateReferences_VariablesEntry> = {
  encode(message: SMSTemplateReferences_VariablesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplateReferences_VariablesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplateReferences_VariablesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplateReferences_VariablesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: SMSTemplateReferences_VariablesEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplateReferences_VariablesEntry>): SMSTemplateReferences_VariablesEntry {
    return SMSTemplateReferences_VariablesEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplateReferences_VariablesEntry>): SMSTemplateReferences_VariablesEntry {
    const message = createBaseSMSTemplateReferences_VariablesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseSMSTemplateReferences_TranslationsEntry(): SMSTemplateReferences_TranslationsEntry {
  return { key: "", value: false };
}

export const SMSTemplateReferences_TranslationsEntry: MessageFns<SMSTemplateReferences_TranslationsEntry> = {
  encode(message: SMSTemplateReferences_TranslationsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== false) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplateReferences_TranslationsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplateReferences_TranslationsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplateReferences_TranslationsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: SMSTemplateReferences_TranslationsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== false) {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplateReferences_TranslationsEntry>): SMSTemplateReferences_TranslationsEntry {
    return SMSTemplateReferences_TranslationsEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplateReferences_TranslationsEntry>): SMSTemplateReferences_TranslationsEntry {
    const message = createBaseSMSTemplateReferences_TranslationsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseSMS(): SMS {
  return { templates: [] };
}

export const SMS: MessageFns<SMS> = {
  encode(message: SMS, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.templates) {
      SMSTemplate.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMS {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMS();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templates.push(SMSTemplate.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMS {
    return {
      templates: globalThis.Array.isArray(object?.templates)
        ? object.templates.map((e: any) => SMSTemplate.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SMS): unknown {
    const obj: any = {};
    if (message.templates?.length) {
      obj.templates = message.templates.map((e) => SMSTemplate.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<SMS>): SMS {
    return SMS.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMS>): SMS {
    const message = createBaseSMS();
    message.templates = object.templates?.map((e) => SMSTemplate.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSMSTemplate(): SMSTemplate {
  return {
    id: "",
    name: "",
    text: "",
    envPhoneNumbers: undefined,
    references: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: undefined,
    active: false,
  };
}

export const SMSTemplate: MessageFns<SMSTemplate> = {
  encode(message: SMSTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.text !== "") {
      writer.uint32(26).string(message.text);
    }
    if (message.envPhoneNumbers !== undefined) {
      SMSEnvPhoneNumbers.encode(message.envPhoneNumbers, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      SMSTemplateReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(58).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(66).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(74).string(message.updatedBy);
    }
    if (message.active !== false) {
      writer.uint32(80).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.envPhoneNumbers = SMSEnvPhoneNumbers.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = SMSTemplateReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      envPhoneNumbers: isSet(object.envPhoneNumbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.envPhoneNumbers)
        : isSet(object.env_phone_numbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.env_phone_numbers)
        : undefined,
      references: isSet(object.references) ? SMSTemplateReferences.fromJSON(object.references) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: SMSTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.envPhoneNumbers !== undefined) {
      obj.envPhoneNumbers = SMSEnvPhoneNumbers.toJSON(message.envPhoneNumbers);
    }
    if (message.references !== undefined) {
      obj.references = SMSTemplateReferences.toJSON(message.references);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSTemplate>): SMSTemplate {
    return SMSTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSTemplate>): SMSTemplate {
    const message = createBaseSMSTemplate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.text = object.text ?? "";
    message.envPhoneNumbers = (object.envPhoneNumbers !== undefined && object.envPhoneNumbers !== null)
      ? SMSEnvPhoneNumbers.fromPartial(object.envPhoneNumbers)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? SMSTemplateReferences.fromPartial(object.references)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? undefined;
    message.active = object.active ?? false;
    return message;
  },
};

function createBaseSMSCreateTemplate(): SMSCreateTemplate {
  return { id: "", name: "", text: "", envPhoneNumbers: undefined, references: undefined, active: false };
}

export const SMSCreateTemplate: MessageFns<SMSCreateTemplate> = {
  encode(message: SMSCreateTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.text !== "") {
      writer.uint32(26).string(message.text);
    }
    if (message.envPhoneNumbers !== undefined) {
      SMSEnvPhoneNumbers.encode(message.envPhoneNumbers, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      SMSTemplateReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    if (message.active !== false) {
      writer.uint32(48).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSCreateTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSCreateTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.envPhoneNumbers = SMSEnvPhoneNumbers.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = SMSTemplateReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSCreateTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      envPhoneNumbers: isSet(object.envPhoneNumbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.envPhoneNumbers)
        : isSet(object.env_phone_numbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.env_phone_numbers)
        : undefined,
      references: isSet(object.references) ? SMSTemplateReferences.fromJSON(object.references) : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: SMSCreateTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.envPhoneNumbers !== undefined) {
      obj.envPhoneNumbers = SMSEnvPhoneNumbers.toJSON(message.envPhoneNumbers);
    }
    if (message.references !== undefined) {
      obj.references = SMSTemplateReferences.toJSON(message.references);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSCreateTemplate>): SMSCreateTemplate {
    return SMSCreateTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSCreateTemplate>): SMSCreateTemplate {
    const message = createBaseSMSCreateTemplate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.text = object.text ?? "";
    message.envPhoneNumbers = (object.envPhoneNumbers !== undefined && object.envPhoneNumbers !== null)
      ? SMSEnvPhoneNumbers.fromPartial(object.envPhoneNumbers)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? SMSTemplateReferences.fromPartial(object.references)
      : undefined;
    message.active = object.active ?? false;
    return message;
  },
};

function createBaseUpdateSMSEnvPhoneNumbers(): UpdateSMSEnvPhoneNumbers {
  return { sandbox: undefined, preRelease: undefined, live: undefined };
}

export const UpdateSMSEnvPhoneNumbers: MessageFns<UpdateSMSEnvPhoneNumbers> = {
  encode(message: UpdateSMSEnvPhoneNumbers, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sandbox !== undefined) {
      writer.uint32(10).string(message.sandbox);
    }
    if (message.preRelease !== undefined) {
      writer.uint32(18).string(message.preRelease);
    }
    if (message.live !== undefined) {
      writer.uint32(26).string(message.live);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSMSEnvPhoneNumbers {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSMSEnvPhoneNumbers();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sandbox = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.preRelease = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.live = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSMSEnvPhoneNumbers {
    return {
      sandbox: isSet(object.sandbox) ? globalThis.String(object.sandbox) : undefined,
      preRelease: isSet(object.preRelease)
        ? globalThis.String(object.preRelease)
        : isSet(object.pre_release)
        ? globalThis.String(object.pre_release)
        : undefined,
      live: isSet(object.live) ? globalThis.String(object.live) : undefined,
    };
  },

  toJSON(message: UpdateSMSEnvPhoneNumbers): unknown {
    const obj: any = {};
    if (message.sandbox !== undefined) {
      obj.sandbox = message.sandbox;
    }
    if (message.preRelease !== undefined) {
      obj.preRelease = message.preRelease;
    }
    if (message.live !== undefined) {
      obj.live = message.live;
    }
    return obj;
  },

  create(base?: DeepPartial<UpdateSMSEnvPhoneNumbers>): UpdateSMSEnvPhoneNumbers {
    return UpdateSMSEnvPhoneNumbers.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateSMSEnvPhoneNumbers>): UpdateSMSEnvPhoneNumbers {
    const message = createBaseUpdateSMSEnvPhoneNumbers();
    message.sandbox = object.sandbox ?? undefined;
    message.preRelease = object.preRelease ?? undefined;
    message.live = object.live ?? undefined;
    return message;
  },
};

function createBaseSMSUpdateTemplate(): SMSUpdateTemplate {
  return {
    id: "",
    name: undefined,
    text: undefined,
    envPhoneNumbers: undefined,
    references: undefined,
    active: undefined,
  };
}

export const SMSUpdateTemplate: MessageFns<SMSUpdateTemplate> = {
  encode(message: SMSUpdateTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.text !== undefined) {
      writer.uint32(26).string(message.text);
    }
    if (message.envPhoneNumbers !== undefined) {
      UpdateSMSEnvPhoneNumbers.encode(message.envPhoneNumbers, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      SMSTemplateReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    if (message.active !== undefined) {
      writer.uint32(48).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSUpdateTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSUpdateTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.envPhoneNumbers = UpdateSMSEnvPhoneNumbers.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = SMSTemplateReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSUpdateTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      text: isSet(object.text) ? globalThis.String(object.text) : undefined,
      envPhoneNumbers: isSet(object.envPhoneNumbers)
        ? UpdateSMSEnvPhoneNumbers.fromJSON(object.envPhoneNumbers)
        : isSet(object.env_phone_numbers)
        ? UpdateSMSEnvPhoneNumbers.fromJSON(object.env_phone_numbers)
        : undefined,
      references: isSet(object.references) ? SMSTemplateReferences.fromJSON(object.references) : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : undefined,
    };
  },

  toJSON(message: SMSUpdateTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.text !== undefined) {
      obj.text = message.text;
    }
    if (message.envPhoneNumbers !== undefined) {
      obj.envPhoneNumbers = UpdateSMSEnvPhoneNumbers.toJSON(message.envPhoneNumbers);
    }
    if (message.references !== undefined) {
      obj.references = SMSTemplateReferences.toJSON(message.references);
    }
    if (message.active !== undefined) {
      obj.active = message.active;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSUpdateTemplate>): SMSUpdateTemplate {
    return SMSUpdateTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSUpdateTemplate>): SMSUpdateTemplate {
    const message = createBaseSMSUpdateTemplate();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.text = object.text ?? undefined;
    message.envPhoneNumbers = (object.envPhoneNumbers !== undefined && object.envPhoneNumbers !== null)
      ? UpdateSMSEnvPhoneNumbers.fromPartial(object.envPhoneNumbers)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? SMSTemplateReferences.fromPartial(object.references)
      : undefined;
    message.active = object.active ?? undefined;
    return message;
  },
};

function createBaseSMSDeleteTemplate(): SMSDeleteTemplate {
  return { id: "" };
}

export const SMSDeleteTemplate: MessageFns<SMSDeleteTemplate> = {
  encode(message: SMSDeleteTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSDeleteTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSDeleteTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSDeleteTemplate {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: SMSDeleteTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSDeleteTemplate>): SMSDeleteTemplate {
    return SMSDeleteTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSDeleteTemplate>): SMSDeleteTemplate {
    const message = createBaseSMSDeleteTemplate();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseSMSDuplicateTemplate(): SMSDuplicateTemplate {
  return { id: "", name: "", text: "", envPhoneNumbers: undefined, references: undefined, active: false };
}

export const SMSDuplicateTemplate: MessageFns<SMSDuplicateTemplate> = {
  encode(message: SMSDuplicateTemplate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.text !== "") {
      writer.uint32(26).string(message.text);
    }
    if (message.envPhoneNumbers !== undefined) {
      SMSEnvPhoneNumbers.encode(message.envPhoneNumbers, writer.uint32(34).fork()).join();
    }
    if (message.references !== undefined) {
      SMSTemplateReferences.encode(message.references, writer.uint32(42).fork()).join();
    }
    if (message.active !== false) {
      writer.uint32(48).bool(message.active);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SMSDuplicateTemplate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSMSDuplicateTemplate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.envPhoneNumbers = SMSEnvPhoneNumbers.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.references = SMSTemplateReferences.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.active = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SMSDuplicateTemplate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      envPhoneNumbers: isSet(object.envPhoneNumbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.envPhoneNumbers)
        : isSet(object.env_phone_numbers)
        ? SMSEnvPhoneNumbers.fromJSON(object.env_phone_numbers)
        : undefined,
      references: isSet(object.references) ? SMSTemplateReferences.fromJSON(object.references) : undefined,
      active: isSet(object.active) ? globalThis.Boolean(object.active) : false,
    };
  },

  toJSON(message: SMSDuplicateTemplate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.envPhoneNumbers !== undefined) {
      obj.envPhoneNumbers = SMSEnvPhoneNumbers.toJSON(message.envPhoneNumbers);
    }
    if (message.references !== undefined) {
      obj.references = SMSTemplateReferences.toJSON(message.references);
    }
    if (message.active !== false) {
      obj.active = message.active;
    }
    return obj;
  },

  create(base?: DeepPartial<SMSDuplicateTemplate>): SMSDuplicateTemplate {
    return SMSDuplicateTemplate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SMSDuplicateTemplate>): SMSDuplicateTemplate {
    const message = createBaseSMSDuplicateTemplate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.text = object.text ?? "";
    message.envPhoneNumbers = (object.envPhoneNumbers !== undefined && object.envPhoneNumbers !== null)
      ? SMSEnvPhoneNumbers.fromPartial(object.envPhoneNumbers)
      : undefined;
    message.references = (object.references !== undefined && object.references !== null)
      ? SMSTemplateReferences.fromPartial(object.references)
      : undefined;
    message.active = object.active ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
